import { Helmet } from 'react-helmet-async';
import { VendorCatalogView } from '../../../components/dashboard/admin/vendor-catalog';

// ----------------------------------------------------------------------

export default function VendorCatalog() {
  return (
    <>
      <Helmet>
        <title>Admin Vendor Catalog | Platform Solutions</title>
      </Helmet>
      
      <VendorCatalogView />
    </>
  );
}
